import React from 'react';
import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';
import LoginPage from './features/loginFeature/Pages/LoginPage';
// import bckgrndImage from './assests/background.jpg'
import CalendarPageTest from './features/calendar/Pages/CalendarPageTest';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import LenderLandingPage from './features/Lender/features/Landing/Pages/LenderLandingPage';
import InspectorLandingPage from './features/Inspector/Features/Landing/InspectorLandingPage';

import AdminUserLandingPage from './features/AdminUser/Pages/AdminUserLandingPage';


//Banks
import AddUpdateHQBankTabsPage from './features/AdminUser/Features/Banks/AddUpdateBankHQ/Pages/AddUpdateHQBankTabsPage';
import AddUpdateBankBranchTabsPage from './features/AdminUser/Features/Banks/AddUpdateBankBranch/Pages/AddUpdateBankBranchTabsPage';
import AddUpdateBankEETabsPage from './features/AdminUser/Features/Banks/AddUpdateBankEE/Pages/AddUpdateBankEETabsPage';

// INSPECTORS
import AddUpdateHQInspectionTabsPage from './features/AdminUser/Features/Inspector/AddUpdateHQInspectionAgency/Pages/AddUpdateHQInspectionTabsPage';
import AddUpdateInspectionAgencyEETabsPage from './features/AdminUser/Features/Inspector/AddUpdateInspectionAgencyEE/Pages/AddUpdateInspectionAgencyEETabsPage';
import AddUpdateInspectionAgencyBranchTabsPage from './features/AdminUser/Features/Inspector/AddUpdateInspectionAgencyBranch/Pages/AddUpdateInspectionAgencyBranchTabsPage';

//BUILDERS
import AddUpdateHQBuilderTabsPage from './features/AdminUser/Features/Builder/AddUpdateBuilderHQ/Pages/AddUpdateHQBuilderTabsPage';
import AddUpdateBuilderEETabsPage from './features/AdminUser/Features/Builder/AddUpdateBuilderEE/Pages/AddUpdateBuilderEETabsPage';
import AddUpdateBuilderBranchTabsPage from './features/AdminUser/Features/Builder/AddUpdateBuilderBranch/Pages/AddUpdateBuilderBranchTabsPage';



import LoginGateway from './features/loginFeature/Pages/LoginGateway';




function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<LoginPage/>}></Route>
          <Route path='/Gateway' element={<LoginGateway/>}></Route>

          
          <Route path='/calendar' element={<CalendarPageTest/>}></Route>
          <Route path='/lender' element={<LenderLandingPage/>}></Route>
          <Route path='/inspectorlanding' element={<InspectorLandingPage/>}></Route>

          {/* ADMIN SECTION */}
          <Route path='/UserAdmLandingPage' element={<AdminUserLandingPage/>}></Route>

          {/* BANKS */}
          <Route path='/AddUpdateBank' element={<AddUpdateHQBankTabsPage/>}></Route>
          <Route path='/BankBranchTabsPage' element={<AddUpdateBankBranchTabsPage/>}></Route>
          <Route path='/AddUpdateBankEmployeePage' element={<AddUpdateBankEETabsPage/>}></Route>
          
          {/* <Route path='/AddBankPage' element={<AddBankPage/>}></Route> */}

          {/* INSPECTORS */}
          {/* <Route path='/AddInspectingBusiness' element={<AddInspectingBusiness/>}></Route> */}
          

          <Route path='/AddUpdateInspectionHQ' element={<AddUpdateHQInspectionTabsPage/>}></Route>
          <Route path='/AddUpdateinspectionAgencyEE' element={<AddUpdateInspectionAgencyEETabsPage/>}></Route>
          <Route path='/AddUpdateinspectionBranch' element={<AddUpdateInspectionAgencyBranchTabsPage/>}></Route>

          
          {/* BUILDERS */}
          {/* <Route path='/AddBuilderBusinessPage' element={<AddBuilderBusinessPage/>}></Route> */}
          {/* <Route path='/AddBuilderEmployeePage' element={<AddBuilderEmployeePage/>}></Route> */}

          <Route path='/AddUpdateBuilderHQ' element={<AddUpdateHQBuilderTabsPage/>}></Route>
          <Route path='/AddUpdateBuilderEE' element={<AddUpdateBuilderEETabsPage/>}></Route>
          <Route path='/AddUpdateBuilderBranch' element={<AddUpdateBuilderBranchTabsPage/>}></Route>

          

          

          









        </Routes>
      </Router>

    </div>
  );
}

export default App;
